export const importVirtualListStore = () => import(
  '../../_components/virtualList/virtualListStore.js'
)
